<template lang="html">
    <div class="z-module-properties-input">
        <div class="z-module-properties-input__item" v-for="code in props" v-bind:key="`prices-settings-field-${code}`">
            <z-input
                v-if="localValue[code] && (['text', 'number'].indexOf(localValue[code].type)+1)"
                v-model="localValue[code].value"
                v-bind:type="localValue[code].type"
                v-bind:name="localValue[code].code"
                v-bind:label="localValue[code].name"
                v-bind:placeholder="localValue[code].placeholder"
                v-bind:error="errors.first(localValue[code].code)"
                v-bind:data-vv-name="localValue[code].code"
                v-bind:data-vv-as="' '"
                v-bind:required="true"
                v-validate="{required: true}"
            ></z-input>

            <z-select
                v-else-if="localValue[code] && localValue[code].type == 'select'"
                v-model="localValue[code].value"
                v-bind:name="localValue[code].code"
                v-bind:label="localValue[code].name"
                v-bind:error="errors.first(localValue[code].code)"
                v-bind:data-vv-name="localValue[code].code"
                v-bind:data-vv-as="' '"
                v-bind:required="true"
                v-validate="{required: true}"
            >
                <option value="" selected disabled>{{ localValue[code].placeholder || 'Укажите значение' }}</option>
                <option
                    v-for="(label, value) in localValue[code].values"
                    v-bind:key="`prices-settings-field-${code}-select-${value}`"
                    v-bind:value="value"
                >{{ label }}</option>
            </z-select>

            <ZCheckList
                v-else-if="localValue[code] && localValue[code].type == 'checkbox' && localValue[code].multiply"
                v-bind:label="localValue[code].name" class="z-module-properties-input__item-container"
            >
                <z-check
                    v-for="(label, value) in localValue[code].values"
                    v-bind:key="`z-module-prop-input-${localValue[code].code}-${value}`"
                    v-bind:value="value"
                    v-bind:label="label"
                    v-model="localValue[code].value"
                    v-bind:name="`${localValue[code].code}-${value}`"
                    v-bind:error="errors.first(`${localValue[code].code}-${value}`)"
                    v-bind:data-vv-name="`${localValue[code].code}-${value}`"
                    v-bind:data-vv-as="' '"
                    v-validate="{}"
                ></z-check>
            </ZCheckList>

            <div
                v-if="localValue[code] && localValue[code].help"
                v-html="localValue[code].help"
                class="z-module-properties-input__description"
            ></div>
        </div>
    </div>
</template>
<script>
    import ZInput  from './ZInput';
    import ZSelect from './ZSelect';
    import ZCheck  from './ZCheck';
    import ZCheckList  from './ZCheckList';
    export default {
        name: 'z-module-properties-input',
        components: { ZInput, ZSelect, ZCheck, ZCheckList },
        props: {
            value: {
                type: Object,
                default: () => ({}),
                required: true
            },
            properties: {
                type: Array,
                default: () => [],
                required: true
            }
        },
        computed: {
            props() {
                return this.$props.properties
            },
            localValue: {
                get: function () {
                    return Object.assign({}, this.$props.value);
                },
                set: function (value) {
                    this.$emit('change', Object.assign({}, value));
                }
            }
        },
        methods: {
            validate() {
                return this.$validator.validateAll();
            }
        }
    }
</script>
<style lang="sass">
    .z-module-properties-input
        .z-module-properties-input__item-container
            margin: 0 0 10px 0
        .z-module-properties-input__description
            font-size: 10px
            line-height: 120%
            margin: -8px 0 15px 0
            color: rgba(0, 0, 0, 0.54)
</style>


// WEBPACK FOOTER //
// ZModulePropertiesInput.vue?394a972d